function Svg({ children, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  );
}

const stroke = {
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function IconSearch(props) {
  return (
    <Svg {...props}>
      <circle cx="11" cy="11" r="6.25" {...stroke} />
      <path d="M16 16.5L20.5 21" {...stroke} />
    </Svg>
  );
}

export function IconChevronLeft(props) {
  return (
    <Svg {...props}>
      <path d="M14.5 5.5L8 12l6.5 6.5" {...stroke} />
    </Svg>
  );
}

export function IconChevronRight(props) {
  return (
    <Svg {...props}>
      <path d="M9.5 5.5L16 12l-6.5 6.5" {...stroke} />
    </Svg>
  );
}

export function IconChevronsLeft(props) {
  return (
    <Svg {...props}>
      <path d="M11 6L6 12l5 6" {...stroke} />
      <path d="M18 6l-5 6 5 6" {...stroke} />
    </Svg>
  );
}

export function IconChevronsRight(props) {
  return (
    <Svg {...props}>
      <path d="M13 6l5 6-5 6" {...stroke} />
      <path d="M6 6l5 6-5 6" {...stroke} />
    </Svg>
  );
}

export function IconChevronDown(props) {
  return (
    <Svg {...props}>
      <path d="M6 9.5l6 6 6-6" {...stroke} />
    </Svg>
  );
}

export function IconCalendar(props) {
  return (
    <Svg {...props}>
      <rect x="3.5" y="5" width="17" height="15" rx="2" {...stroke} />
      <path d="M8 3.5V7M16 3.5V7M3.5 10h17" {...stroke} />
    </Svg>
  );
}

export function IconEye(props) {
  return (
    <Svg {...props}>
      <path d="M2.5 12S6 6.5 12 6.5 21.5 12 21.5 12 18 17.5 12 17.5 2.5 12 2.5 12z" {...stroke} />
      <circle cx="12" cy="12" r="2.4" {...stroke} />
    </Svg>
  );
}

export function IconEyeOff(props) {
  return (
    <Svg {...props}>
      <path d="M4 5.5l16 13" {...stroke} />
      <path d="M9.2 9.4A3.2 3.2 0 0012 15.2c.7 0 1.3-.2 1.8-.6" {...stroke} />
      <path d="M6.2 7.6C4.2 9 2.8 12 2.8 12S6.2 17.5 12 17.5c1.3 0 2.5-.3 3.5-.8M10 6.7c.6-.1 1.3-.2 2-.2 5.8 0 9.2 5.5 9.2 5.5s-.7 1.3-2 2.6" {...stroke} />
    </Svg>
  );
}

export function IconSun(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="3.2" {...stroke} />
      <path d="M12 3.5v1.8M12 18.7v1.8M3.5 12h1.8M18.7 12h1.8M6 6l1.3 1.3M16.7 16.7L18 18M18 6l-1.3 1.3M7.3 16.7L6 18" {...stroke} />
    </Svg>
  );
}

export function IconMoon(props) {
  return (
    <Svg {...props}>
      <path d="M15.5 3.8A7.8 7.8 0 1019.2 16 6.2 6.2 0 0115.5 3.8z" {...stroke} />
    </Svg>
  );
}

export function IconPlus(props) {
  return (
    <Svg {...props}>
      <path d="M12 5.5v13M5.5 12h13" {...stroke} />
    </Svg>
  );
}

export function IconCheck(props) {
  return (
    <Svg {...props}>
      <path d="M6.5 12.5l3.2 3.2 7.8-8" {...stroke} />
    </Svg>
  );
}

export function IconClock(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" {...stroke} />
      <path d="M12 8v4.5l3 2" {...stroke} />
    </Svg>
  );
}

export function IconUser(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="8.5" r="3.1" {...stroke} />
      <path d="M5.2 19.2c1.2-2.8 3.5-4.2 6.8-4.2s5.6 1.4 6.8 4.2" {...stroke} />
    </Svg>
  );
}

export function IconMaximize(props) {
  return (
    <Svg {...props}>
      <path d="M9 4.5H4.5V9M15 4.5h4.5V9M9 19.5H4.5V15M15 19.5h4.5V15" {...stroke} />
    </Svg>
  );
}

export function IconHelp(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" {...stroke} />
      <path d="M9.5 9.4a2.5 2.5 0 114.2 1.8c-.8.7-1.7 1.1-1.7 2.3" {...stroke} />
      <path d="M12 17.2h.01" {...stroke} />
    </Svg>
  );
}

export function IconClose(props) {
  return (
    <Svg {...props}>
      <path d="M7 7l10 10M17 7L7 17" {...stroke} />
    </Svg>
  );
}

export function IconDetails(props) {
  return (
    <Svg {...props}>
      <path d="M5 7.5h14M5 12h14M5 16.5h14" {...stroke} />
    </Svg>
  );
}

export function IconLink(props) {
  return (
    <Svg {...props}>
      <path d="M10 13.5l-1.2 1.2a3.2 3.2 0 01-4.5-4.5L6.5 8" {...stroke} />
      <path d="M14 10.5l1.2-1.2a3.2 3.2 0 114.5 4.5L17.5 16" {...stroke} />
      <path d="M9.2 14.8l5.6-5.6" {...stroke} />
    </Svg>
  );
}

export function IconImage(props) {
  return (
    <Svg {...props}>
      <rect x="4" y="5" width="16" height="14" rx="2" {...stroke} />
      <circle cx="9" cy="10" r="1.3" {...stroke} />
      <path d="M5 16.5l4.2-3.6 2.6 2.2 2.2-1.8L19 16.5" {...stroke} />
    </Svg>
  );
}

export function IconCheckSquare(props) {
  return (
    <Svg {...props}>
      <rect x="4.5" y="4.5" width="15" height="15" rx="3" {...stroke} />
      <path d="M8.2 12.1l2.4 2.4 5.2-5.4" {...stroke} />
    </Svg>
  );
}

export function IconRepeat(props) {
  return (
    <Svg {...props}>
      <path d="M16.6 7.6A5.4 5.4 0 0 0 7.2 6.4L5.6 7.8" {...stroke} />
      <path d="M5.2 4.6v3.4h3.4" {...stroke} />
      <path d="M7.4 16.4A5.4 5.4 0 0 0 16.8 17.6l1.6-1.4" {...stroke} />
      <path d="M18.8 19.4v-3.4h-3.4" {...stroke} />
    </Svg>
  );
}

export function IconGrip(props) {
  return (
    <svg viewBox="0 0 10 16" width="10" height="16" aria-hidden="true" {...props}>
      {[2, 8].map((x) =>
        [2.5, 8, 13.5].map((y) => <circle key={`${x}-${y}`} cx={x} cy={y} r="1.15" fill="currentColor" />)
      )}
    </svg>
  );
}

export function IconSquare(props) {
  return (
    <Svg {...props}>
      <rect x="6" y="6" width="12" height="12" rx="1.5" {...stroke} />
    </Svg>
  );
}

export function IconCircle(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="5" {...stroke} />
    </Svg>
  );
}

export function IconDotsVertical(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="5.5" r="1.35" fill="currentColor" />
      <circle cx="12" cy="12" r="1.35" fill="currentColor" />
      <circle cx="12" cy="18.5" r="1.35" fill="currentColor" />
    </Svg>
  );
}

export function IconList(props) {
  return (
    <Svg {...props}>
      <path d="M10 7h9M10 12h9M10 17h9" {...stroke} />
      <path d="M5.5 7h.01M5.5 12h.01M5.5 17h.01" {...stroke} strokeWidth="2.6" />
    </Svg>
  );
}

export function IconMenu(props) {
  return (
    <Svg {...props}>
      <path d="M4.5 7h15M4.5 12h15M4.5 17h15" {...stroke} />
    </Svg>
  );
}

export function IconPencil(props) {
  return (
    <Svg {...props}>
      <path d="M13.2 6.2l4.6 4.6L8.4 20.2H3.8v-4.6L13.2 6.2z" {...stroke} />
      <path d="M11.4 8l4.6 4.6" {...stroke} />
    </Svg>
  );
}

export function IconHighlight(props) {
  return (
    <Svg {...props}>
      <path
        d="M12 21.2a1.2 1.2 0 0 1-1.1-1.7c.3-.6.1-1.2-.4-1.6-.4-.3-.6-.8-.6-1.3A1.7 1.7 0 0 1 11.6 15h2.1a4.6 4.6 0 0 0 4.6-4.6A8.4 8.4 0 0 0 12 3.2 8.6 8.6 0 0 0 3.4 12a8.8 8.8 0 0 0 8.6 9.2z"
        {...stroke}
      />
      <circle cx="8.1" cy="9.1" r="1.15" fill="currentColor" />
      <circle cx="12" cy="7.2" r="1.15" fill="currentColor" />
      <circle cx="15.5" cy="9.5" r="1.15" fill="currentColor" />
    </Svg>
  );
}

export function IconNoColor(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8" {...stroke} />
      <path d="M6.4 17.6L17.6 6.4" {...stroke} />
    </Svg>
  );
}

export function IconMinus(props) {
  return (
    <Svg {...props}>
      <path d="M6 12h12" {...stroke} />
    </Svg>
  );
}
